const DEFAULT_ACCENT_COLOR = '#227ebd';
const DEFAULT_PAGE_BACKGROUND_COLOR = '#f3f7fb';

const normalizeHex = (value?: string): string => {
  const raw = String(value || '').trim();
  if (/^#[0-9a-fA-F]{6}$/.test(raw)) return raw.toLowerCase();
  if (/^#[0-9a-fA-F]{3}$/.test(raw)) {
    const [, r, g, b] = raw;
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
  }
  return DEFAULT_ACCENT_COLOR;
};

const hexToRgb = (hex: string): { r: number; g: number; b: number } => {
  const normalized = normalizeHex(hex).slice(1);
  return {
    r: parseInt(normalized.slice(0, 2), 16),
    g: parseInt(normalized.slice(2, 4), 16),
    b: parseInt(normalized.slice(4, 6), 16)
  };
};

const rgbToHex = (r: number, g: number, b: number): string => {
  const toHex = (part: number) => Math.round(Math.max(0, Math.min(255, part))).toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

const mix = (color: string, target: string, amount: number): string => {
  const sourceRgb = hexToRgb(color);
  const targetRgb = hexToRgb(target);
  return rgbToHex(
    sourceRgb.r + (targetRgb.r - sourceRgb.r) * amount,
    sourceRgb.g + (targetRgb.g - sourceRgb.g) * amount,
    sourceRgb.b + (targetRgb.b - sourceRgb.b) * amount
  );
};

export const getFormThemeColors = (theme?: { accentColor?: string; backgroundColor?: string }) => {
  const accentColor = normalizeHex(theme?.accentColor);
  const pageBackgroundColor = theme?.backgroundColor || mix(accentColor, '#ffffff', 0.9) || DEFAULT_PAGE_BACKGROUND_COLOR;
  const accentSoftColor = mix(accentColor, '#ffffff', 0.86);
  const accentBorderColor = mix(accentColor, '#ffffff', 0.62);
  const accentShadowColor = `rgba(${hexToRgb(accentColor).r}, ${hexToRgb(accentColor).g}, ${hexToRgb(accentColor).b}, 0.18)`;

  return {
    accentColor,
    pageBackgroundColor,
    accentSoftColor,
    accentBorderColor,
    accentShadowColor
  };
};